module.exports = __webpack_public_path__ + "files/be82b429a255612b7e15b123d55a2ded.png";